import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination, EffectCoverflow } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { fetchPatientStory, fetchPatientVideos } from "../Adapter/HomePageAdapter";
import { baseImage_path } from "../variables/Variables";
import playIcon from "../assets/images/speci-detail/vdoplybtn.png";
import fallbackImage from "../assets/images/pat1.png";
import feed from "../assets/images/feed.png";
import userIcn from "../assets/images/user-slraheja-profile.png";
import kidneytrans from "../assets/images/kidney-transplant.jpg";
import kneesurg from "../assets/images/knee-surgery.jpg";

import leftarrow from "../assets/images/leftgrarw.svg";
import rightarrow from "../assets/images/rightgrarw.svg";

const PatientStory = () => {
    const [videoTestimonials, setVideoTestimonials] = useState([]);
    const [textTestimonials, setTextTestimonials] = useState([]);
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [videoResponse, textResponse] = await Promise.all([
                    fetchPatientVideos(),
                    fetchPatientStory()
                ]);

                // if (videoResponse?.data) {
                //     const sanitizedVideos = videoResponse.data.map((video) => ({
                //         ...video,
                //         video_link: video.video_link?.replace("watch?v=", "embed/"),
                //     }));
                //     setVideoTestimonials(sanitizedVideos);
                // }

                if (videoResponse?.data) {
                    const sanitizedVideos = videoResponse.data.map((video) => {
                        const videoIdMatch = video.video_link?.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/|.+\?v=))([^&]+)/);
                        const videoId = videoIdMatch ? videoIdMatch[1] : null;

                        return {
                            ...video,
                            video_link: video.video_link?.replace("watch?v=", "embed/"),
                            thumbnail: videoId
                                ? `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg` // High-quality thumbnail
                                : fallbackImage
                        };
                    });

                    setVideoTestimonials(sanitizedVideos);
                }

                if (textResponse?.data) {
                    setTextTestimonials(textResponse.data);
                }
            } catch (err) {
                setError("Failed to load patient stories.");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading) return <div>Loading...</div>;
    if (error) return <div>{error}</div>;

    const feedbackStory = [
        { img: userIcn, name: "Narasimha Shenoy", designation: "Client", heading: "Smooth Surgery & Excellent Recovery Support", review: "My wife Jayashree Shenoy was operated on left knee replacement on Mar 6,2025 and discharged on March 10. Our experience throughout was very good. Special Thanks to Dr.Satish Mutha for surgery and excellent recovery and timely assistance." },
        { img: userIcn, name: "Mayur Andhale", designation: "Local Guide", heading: "A Comfortable & Caring Hospital Experience", review: "SL Raheja Hospital made my hospital experience much better than I expected. The ambience is serene, which made a big difference in helping me stay positive during my treatment. Cleanliness is clearly a priority here, and it shows – everything was spotless and well-organized." },
        { img: userIcn, name: "Novela Patrao", designation: "Local Guide", heading: "Compassionate Care When It Mattered Most", review: "Had to get my mom to the hospital recently, we spent about 8 days here with 5 days in the ICU. The entire staff including the doctor's, nurses, security, TpA and admissions staff were all genuinely helpful and caring." },
        { img: userIcn, name: "Shamshad Alam Idrishi", designation: "Client", heading: "Strong Support & Successful Treatment Journey", review: "Mahim West South Mumbai..Raheja Hospital Fortis Full supportive And strongly Follow-up by Umesh Sharma sir, Finance by, Trust & treatment very good at six month of my Baby Doing very well cleft lip surgery By, Dr Toufiq Bohra's Oral & maxillofacial cleft surgeon, & Doctor,Nurse team very nice treatment." },
        { img: userIcn, name: "Sejal Padwal", designation: "Lead Designer", heading: "Wonderful Maternity Care & Hassle-Free Experience", review: "I recently had delivery at S L Raheja Hospital, Mahim and the experience have been really great and nice... The hospital staff, nurses, doctor's even service staff all are incredible and helpful throughout my stay.. The entire billing, TPA process was hassle free.. I would like to recommend it to others. Thank you to the entire staff." },
        { img: userIcn, name: "DR HEMANG KOPPIKAR", designation: "Local Guide", heading: "Truly Compassionate & Dedicated Medical Team", review: "I am writing this with sincere heartfelt gratitude for the excellent compassionate, quietly efficient, sympathetic and empathetic care given, and also ongoing, by ALL your Nursing, as well as ALL other Supporting Staff in OT, Wards etc. for my patient Ms." },
    ];
    const patientStory = [
        { img: kidneytrans },
        { img: kneesurg },
        { img: kidneytrans },
        { img: kneesurg },
        { img: kidneytrans },
        { img: kneesurg }
    ];

    return (
        <>
            <section className="section patient">
                <h2 className="section-title"><span>Patient Stories</span></h2>
                <div className="patient-stories">

                    {/* Text Testimonials Slider */}
                    <div className="feedback-stories">
                        <Swiper
                            className="swiper feedvdo-slider"
                            modules={[Autoplay, Pagination, Navigation]}
                            effect="coverflow"
                            centeredSlides={true}
                            initialSlide={3.5}
                            spaceBetween={10}
                            speed={600}
                            preventClicks={true}
                            slidesPerView={1}
                            coverflowEffect={{
                                rotate: 0,
                                stretch: 80,
                                depth: 250,
                                modifier: 1,
                                slideShadows: false,
                            }}
                            direction="horizontal"
                            grabCursor={false}
                            freeMode={false}
                            loop={true}
                            mousewheel={false}
                            keyboard={{ enabled: true }}
                            pagination={{ el: ".swiper-pagination2", clickable: true }}
                            navigation={{
                                nextEl: ".swiper-cust2-next",
                                prevEl: ".swiper-cust2-prev",
                            }}
                            breakpoints={{
                                640: {
                                    slidesPerView: 1,
                                    coverflowEffect: {
                                        rotate: 0,
                                        stretch: 0,
                                        depth: 0,
                                        modifier: 1,
                                        slideShadows: false,
                                    },
                                },
                                1024: {
                                    slidesPerView: 1,
                                    effect: "none",
                                },
                                1200: {
                                    slidesPerView: 3.5,
                                },
                            }}
                        >
                            {feedbackStory.map((feeditem, index) => (
                                <SwiperSlide key={index} className="swiper-slide">
                                    <div className="feed-content">
                                        <div className="img-rating">
                                            <div className="user-img">
                                                {/* <img
                                                    src={feeditem.profile_img ? `${baseImage_path}${feeditem.profile_img.replace(/^\.\/?/, "")}` : feed}
                                                    alt={feeditem.name || "Patient"}
                                                /> */}
                                                <img src={feeditem.img} alt="" />
                                            </div>
                                            <div className="img-rating-inner">
                                                <div className="desg">
                                                    <h5>{feeditem.name}</h5>
                                                    <p>{feeditem.designation}</p>
                                                </div>
                                                <div className="ratingparent">
                                                    <div className="rating">
                                                        {/* {[...Array(5)].map((_, i) => (
                                                            <span key={i}>
                                                                {i < feeditem.rating ? "★" : "☆"}
                                                            </span>
                                                        ))} */}
                                                        <span>★★★★★</span>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="feed-desc">
                                            <h5>{feeditem.heading}</h5>
                                            <p>{feeditem.review}</p>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        <div className="videostory-cta" style={{ cursor: "pointer" }}>
                            <span className="swiper-cust2-prev"> &lt; </span>
                            <div className="vdostory-naviga">
                                <span className="swiper-pagination2"></span>
                            </div>
                            <span className="swiper-cust2-next"> &gt; </span>
                        </div>
                    </div>

                    {/* Video Testimonials Slider */}
                    {/* <div className="video-stories">
                        <Swiper
                            className="opdcarousel thisweek-slider videoslider"
                            modules={[Autoplay, Navigation, Pagination, EffectCoverflow]}
                            loop={true}
                            speed={1500}
                            effect="coverflow"
                            grabCursor={false}
                            centeredSlides={true}
                            watchSlidesProgress={true}
                            watchSlidesVisibility={true}
                            slidesPerView={2.5}
                            coverflowEffect={{
                                rotate: 0,
                                stretch: 150,
                                depth: 250,
                                modifier: 1,
                                slideShadows: false,
                            }}
                            pagination={{ clickable: true, el: ".swiper-pagination1" }}
                            navigation={{
                                nextEl: ".swiper-cust1-next",
                                prevEl: ".swiper-cust1-prev",
                            }}
                            breakpoints={{
                                0: {
                                    slidesPerView: 1.1,
                                    spaceBetween: 16,
                                    coverflowEffect: {
                                        rotate: 0,
                                        stretch: 0,
                                        depth: 100,
                                        modifier: 1,
                                        slideShadows: false,
                                    },
                                },
                                640: {
                                    slidesPerView: 1.3,
                                    stretch: 50,
                                },
                                1024: {
                                    slidesPerView: 2.5,
                                    stretch: 150,
                                },
                            }}

                        >
                            {videoTestimonials.map((video, index) => (
                                <SwiperSlide key={index}>
                                    <div className="thisweek-slider-inner" style={{ borderRadius: "20px", overflow: "hidden" }}>
                                        <div className="overlaywhite"></div>
                                        <img src={video.blog_img ? `${baseImage_path}/${video.blog_img.replace(/^\.\/?/, "")}` : fallbackImage}
                                            alt={video.name || "Patient Video"} />
                                        <img
                                            src={video.thumbnail}
                                            alt={video.name || "Patient Video"}
                                        />
                                        <div className="patient-videoPlaybtn">
                                            <button onClick={() => setSelectedVideo(video.video_link)}>
                                                <img src={playIcon} alt="Play Button" />
                                            </button>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        <div className="videostory-cta" style={{ cursor: "pointer" }}>
                            <span className="swiper-cust1-prev"> &lt; </span>
                            <div className="vdostory-naviga">
                                <span className="swiper-pagination1"></span>
                            </div>
                            <span className="swiper-cust1-next"> &gt; </span>
                        </div>
                    </div> */}
                    {/* <div className="video-stories">
                        <Swiper
                            className="thisweek-slider videoslider"
                            modules={[Autoplay, Navigation, Pagination, EffectCoverflow]}
                            loop={true}
                            speed={1500}
                            effect="coverflow"
                            grabCursor={false}
                            centeredSlides={true}
                            watchSlidesProgress={true}
                            watchSlidesVisibility={true}
                            slidesPerView={1.5}
                            spaceBetween= {100}
                            coverflowEffect={{
                                rotate: 0,
                                stretch: 0,
                                depth: 200,
                                modifier: 1,
                                slideShadows: false,
                            }}
                            pagination={{ clickable: true, el: ".swiper-vdo-pagination" }}
                            navigation={{
                                enabled:true,
                                nextEl: ".swiper-cust1-next",
                                prevEl: ".swiper-cust1-prev",
                            }}
                            autoplay={{
                                delay: 3000,
                                disableOnInteraction: false,
                            }}
                            breakpoints={{
                                0: {
                                    slidesPerView: 1.1,
                                    spaceBetween: 40
                                    // coverflowEffect: {
                                    //     rotate: 0,
                                    //     stretch: 0,
                                    //     depth: 100,
                                    //     modifier: 1,
                                    //     slideShadows: false,
                                    // },
                                },
                                640: {
                                    slidesPerView: 1.5,
                                    spaceBetween:40
                                },
                                1024: {
                                    slidesPerView: 1.5,
                                },
                            }}

                        >
                            {videoTestimonials.map((video, index) => (
                                <SwiperSlide key={index}>
                                    <div className="newvideo-slider-inner">
                                        <div className="overlayblack"></div>
                                        <img
                                            src={video.thumbnail}
                                            alt={video.name || "Patient Video"}
                                        />
                                        <div className="patient-videoPlaybtn">
                                            <button onClick={() => setSelectedVideo(video.video_link)}>
                                                <img src={playIcon} alt="Play Button" />
                                            </button>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        <div className="videoslider-navigation">
                                <span className="swiper-cust1-prev">&lt;</span>
                                <span className="swiper-cust1-next"> &gt;</span>
                        </div>
                            <div className="vdostory-pagination">
                                <span className="swiper-vdo-pagination"></span>
                            </div>
                    </div> */}

                </div>
            </section>

            {/* Video Popup Modal */}
            {selectedVideo && (
                <div className="video-popup" onClick={() => setSelectedVideo(null)}>
                    <div className="video-popup-content">
                        <iframe width="800" height="450" src={selectedVideo} title="Patient Story Video" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                        <button className="close-btn" onClick={() => setSelectedVideo(null)}>✕</button>
                    </div>
                </div>
            )}
        </>
    );
};

export default PatientStory;
